<template>
    <NavIsland />
    <router-view/>
</template>

<script lang="ts">

import {Component, Vue} from "vue-facing-decorator";
import {useColorStore} from "@/stores";
import NavIsland from "@/component/common/NavIsland.vue";

@Component({
  components: { NavIsland }
})
export default class App extends Vue {
  private colorStore = useColorStore();

  mounted() {
    // Apply theme on startup based on persisted store value
    document.documentElement.setAttribute('data-theme', this.colorStore.isLightTheme ? 'light' : 'dark');
  }
}
</script>

<style>

@font-face {
    font-family: TTInterfaces;
    src: url("assets/fonts/TTInterfaces-Medium.ttf");
}

* {
    font-family: TTInterfaces, serif;
}

</style>